import {TSRole} from '../../models/enums/TSRole';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import ILogService = angular.ILogService;

export default class OverdueService {

    private _map: Map<TSRole, Map<TSSchadenfallStatus, boolean>> = new Map<TSRole, Map<TSSchadenfallStatus, boolean>>();

    static $inject = ['$log'];

    /* @ngInject */
    constructor(private $log: ILogService) {

        /*Overdue für Superadmin*/
        let overdueSuperadmin: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueSuperadmin.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueSuperadmin.set(TSSchadenfallStatus.NEU, false);
        overdueSuperadmin.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueSuperadmin.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueSuperadmin.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueSuperadmin.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueSuperadmin.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueSuperadmin.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueSuperadmin.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.SUPER_ADMIN, overdueSuperadmin);

        let overduefsAdmin: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overduefsAdmin.set(TSSchadenfallStatus.IMPORTIERT, false);
        overduefsAdmin.set(TSSchadenfallStatus.NEU, true);
        overduefsAdmin.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus.NEU_PAPIER_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overduefsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overduefsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        overduefsAdmin.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overduefsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overduefsAdmin.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        overduefsAdmin.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overduefsAdmin.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overduefsAdmin.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overduefsAdmin.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.FONDSSUISSE_ADMIN, overduefsAdmin);

        let overduefsSachbearbeiter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overduefsSachbearbeiter.set(TSSchadenfallStatus.IMPORTIERT, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.NEU, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overduefsSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.FONDSSUISSE_SACHBEARBEITER, overduefsSachbearbeiter);

        let overdueAnlaufstelleSachbearbeiter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.ANLAUFSTELLE_SACHBEARBEITER, overdueAnlaufstelleSachbearbeiter);

        let overdueAnlaufstelleVerwalter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.ANLAUFSTELLE_VERWALTER, overdueAnlaufstelleVerwalter);

        let overdueAnlaufstelleSchaetzer: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.ANLAUFSTELLE_SCHAETZER, overdueAnlaufstelleSchaetzer);

        let overdueKantonInspektor: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueKantonInspektor.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.NEU, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueKantonInspektor.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.KANTON_INSPEKTOR, overdueKantonInspektor);

        let overdueKantonVerwalter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueKantonVerwalter.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.NEU, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueKantonVerwalter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.KANTON_VERWALTER, overdueKantonVerwalter);

        let overdueBetroffener: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        overdueBetroffener.set(TSSchadenfallStatus.IMPORTIERT, false);
        overdueBetroffener.set(TSSchadenfallStatus.NEU, true);
        overdueBetroffener.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        overdueBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        overdueBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        overdueBetroffener.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        overdueBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        overdueBetroffener.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        overdueBetroffener.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        overdueBetroffener.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        overdueBetroffener.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        overdueBetroffener.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.BETROFFENER, overdueBetroffener);

    }

    public isOverdueVisibleForStatusAndRole(role: TSRole | undefined, status: TSSchadenfallStatus): boolean {
        if (role) {
            return this.getOverdue(role, status);
        } else {
            this.$log.warn('no role passed');
            return false;
        }
    }

    public getOverdue(role: TSRole, status: TSSchadenfallStatus): boolean {
        if (role) {
            let overdueForRole = this._map.get(role);
            if (overdueForRole) {
                let o: boolean | undefined = overdueForRole.get(status);
                if (o) {
                    return o;
                }
                return false;
            } else {
                this.$log.error('no overdue definitions for role ' + role);
            }
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/OverdueService.ts